import { ArrowLeft } from 'lucide-react';
import { PageHeader } from '@/layouts/PageHeader.js';
import { DocumentEditor } from '@/components/document/DocumentEditor.js';
import { NotesListSidebar } from '@/components/notes/NotesListSidebar.js';
import { useAppContext } from '@/contexts/AppContext.js';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useEffect } from 'react';
import { Button } from '@/components/ui/button.js';

interface OutletContext {
  isMobile: boolean;
}

export function NoteEditorPage() {
  const { currentNote, closeNote } = useAppContext();
  const navigate = useNavigate();
  const { isMobile } = useOutletContext<OutletContext>();

  useEffect(() => {
    // If no note is selected, redirect to notes grid or home on mobile
    if (!currentNote) {
      navigate(isMobile ? '/' : '/notes');
    }
  }, [currentNote, navigate, isMobile]);

  const handleBack = () => {
    closeNote();
    navigate('/');
  };

  if (!currentNote) {
    return null; // Will redirect via useEffect
  }

  return (
    <>
      {/* Notes list sidebar - desktop only */}
      {!isMobile && <NotesListSidebar currentNoteId={currentNote.id} />}

      <div className="flex-1 flex flex-col overflow-hidden">
        <PageHeader
          icon={
            isMobile ? (
              <Button
                variant="ghost"
                size="icon"
                onClick={handleBack}
                className="h-9 w-9"
              >
                <ArrowLeft className="w-5 h-5" />
              </Button>
            ) : undefined
          }
          title={currentNote.title || 'Untitled Note'}
          subtitle={isMobile ? undefined : 'Editing note'}
          isMobile={isMobile}
        />
        <main className={`flex-1 overflow-hidden ${isMobile ? 'mb-bottomnav' : ''}`}>
          <DocumentEditor />
        </main>
      </div>
    </>
  );
}
